import { MODULE_KEYS, FEATURE_KEYS, TELEMETRY_IDS, I18N_KEYS, ROUTE_IDS, ICON_IDS, OPERATION_IDS, } from '../routes/ids.js';
const PLATFORM_TITLE = 'hub.admin.platform.title';
const PLATFORM_DESCRIPTION = 'hub.admin.platform.description';
const ACCESS_INSPECTOR_DESCRIPTION = 'admin.accessInspector.description';
/** Platform-scoped administration surfaces. */
export const PLATFORM_ADMIN_HUB = {
    id: 'hub.admin.platform',
    schemaVersion: 1,
    module: MODULE_KEYS.ADMIN,
    feature: FEATURE_KEYS.NAVIGATION,
    telemetryId: TELEMETRY_IDS.HUB_ADMIN,
    accessibilityLabelKey: I18N_KEYS.HUB_ADMIN_ACCESSIBILITY,
    privacyClassification: 'INTERNAL',
    auditPolicy: 'NONE',
    owner: 'platform',
    titleKey: PLATFORM_TITLE,
    descriptionKey: PLATFORM_DESCRIPTION,
    availability: 'AVAILABLE',
    operationId: OPERATION_IDS.ADMIN_HUB_PLATFORM,
    groups: [
        {
            id: 'platform-admin-core',
            schemaVersion: 1,
            module: MODULE_KEYS.ADMIN,
            feature: FEATURE_KEYS.NAVIGATION,
            telemetryId: TELEMETRY_IDS.HUB_ADMIN_CORE,
            accessibilityLabelKey: I18N_KEYS.HUB_ADMIN_CORE_ACCESSIBILITY,
            privacyClassification: 'INTERNAL',
            auditPolicy: 'NONE',
            owner: 'platform',
            titleKey: PLATFORM_TITLE,
            availability: 'AVAILABLE',
            cards: [
                {
                    id: 'card.platform.organizations', schemaVersion: 1, module: MODULE_KEYS.ADMIN,
                    feature: FEATURE_KEYS.NAVIGATION, telemetryId: TELEMETRY_IDS.CARD_ORGANIZATION,
                    accessibilityLabelKey: I18N_KEYS.CARD_ORGANIZATION_ACCESSIBILITY,
                    privacyClassification: 'INTERNAL', auditPolicy: 'NONE', owner: 'platform',
                    resourceId: 'platform-organizations', routeId: ROUTE_IDS.PLATFORM_ORGANIZATIONS_LIST,
                    titleKey: I18N_KEYS.PAGE_PLATFORM_ORGANIZATIONS_TITLE,
                    descriptionKey: I18N_KEYS.PAGE_PLATFORM_ORGANIZATIONS_DESCRIPTION,
                    iconKey: ICON_IDS.BUSINESS, availability: 'AVAILABLE',
                    operationId: OPERATION_IDS.PLATFORM_ORGANIZATIONS_LIST,
                },
                {
                    id: 'card.platform.users', schemaVersion: 1, module: MODULE_KEYS.ADMIN,
                    feature: FEATURE_KEYS.NAVIGATION, telemetryId: TELEMETRY_IDS.CARD_PLATFORM_USERS,
                    accessibilityLabelKey: I18N_KEYS.CARD_PLATFORM_USERS_ACCESSIBILITY,
                    privacyClassification: 'INTERNAL', auditPolicy: 'NONE', owner: 'platform',
                    resourceId: 'platform-users', routeId: ROUTE_IDS.PLATFORM_USERS_LIST,
                    titleKey: I18N_KEYS.PAGE_PLATFORM_USERS_TITLE,
                    descriptionKey: I18N_KEYS.PAGE_PLATFORM_USERS_DESCRIPTION,
                    iconKey: ICON_IDS.USERS, availability: 'AVAILABLE',
                    operationId: OPERATION_IDS.PLATFORM_USERS_LIST,
                },
                {
                    id: 'card.platform.modules', schemaVersion: 1, module: MODULE_KEYS.ADMIN,
                    feature: FEATURE_KEYS.NAVIGATION, telemetryId: TELEMETRY_IDS.CARD_PLATFORM_MODULES,
                    accessibilityLabelKey: I18N_KEYS.CARD_PLATFORM_MODULES_ACCESSIBILITY,
                    privacyClassification: 'INTERNAL', auditPolicy: 'NONE', owner: 'platform',
                    resourceId: 'platform-modules', routeId: ROUTE_IDS.PLATFORM_MODULES_LIST,
                    titleKey: I18N_KEYS.PAGE_PLATFORM_MODULES_TITLE,
                    descriptionKey: I18N_KEYS.PAGE_PLATFORM_MODULES_DESCRIPTION,
                    iconKey: ICON_IDS.LOCK, availability: 'AVAILABLE',
                    operationId: OPERATION_IDS.PLATFORM_MODULES_LIST,
                },
                {
                    id: 'card.platform.audit', schemaVersion: 1, module: MODULE_KEYS.ADMIN,
                    feature: FEATURE_KEYS.NAVIGATION, telemetryId: TELEMETRY_IDS.CARD_PLATFORM_AUDIT,
                    accessibilityLabelKey: I18N_KEYS.CARD_PLATFORM_AUDIT_ACCESSIBILITY,
                    privacyClassification: 'INTERNAL', auditPolicy: 'NONE', owner: 'platform',
                    resourceId: 'platform-audit', routeId: ROUTE_IDS.PLATFORM_AUDIT_LIST,
                    titleKey: I18N_KEYS.PAGE_PLATFORM_AUDIT_TITLE,
                    descriptionKey: I18N_KEYS.PAGE_PLATFORM_AUDIT_DESCRIPTION,
                    iconKey: ICON_IDS.RECEIPT, availability: 'AVAILABLE',
                    operationId: OPERATION_IDS.PLATFORM_AUDIT_LIST,
                },
                {
                    id: 'card.platform.accessInspector', schemaVersion: 1, module: MODULE_KEYS.ADMIN,
                    feature: FEATURE_KEYS.NAVIGATION, telemetryId: TELEMETRY_IDS.ADMIN_PLATFORM_ACCESS_INSPECTOR,
                    accessibilityLabelKey: I18N_KEYS.PAGE_PLATFORM_ACCESS_INSPECTOR_TITLE,
                    privacyClassification: 'INTERNAL', auditPolicy: 'NONE', owner: 'platform',
                    resourceId: 'platform-access-inspector', routeId: ROUTE_IDS.PLATFORM_ACCESS_INSPECTOR,
                    titleKey: I18N_KEYS.PAGE_PLATFORM_ACCESS_INSPECTOR_TITLE,
                    descriptionKey: ACCESS_INSPECTOR_DESCRIPTION, iconKey: ICON_IDS.LOCK,
                    availability: 'AVAILABLE', operationId: OPERATION_IDS.ACCESS_READ_PERMISSIONS,
                },
                {
                    id: 'card.platform.health', schemaVersion: 1, module: MODULE_KEYS.ADMIN,
                    feature: FEATURE_KEYS.NAVIGATION, telemetryId: TELEMETRY_IDS.CARD_PLATFORM_HEALTH,
                    accessibilityLabelKey: I18N_KEYS.CARD_PLATFORM_HEALTH_ACCESSIBILITY,
                    privacyClassification: 'INTERNAL', auditPolicy: 'NONE', owner: 'platform',
                    resourceId: 'platform-health', routeId: ROUTE_IDS.PLATFORM_HEALTH,
                    titleKey: I18N_KEYS.PAGE_PLATFORM_HEALTH_TITLE,
                    descriptionKey: I18N_KEYS.PAGE_PLATFORM_HEALTH_DESCRIPTION,
                    iconKey: ICON_IDS.SUCCESS, availability: 'AVAILABLE',
                    operationId: OPERATION_IDS.PLATFORM_HEALTH_CHECK,
                },
                {
                    id: 'card.platform.supportDelegations', schemaVersion: 1, module: MODULE_KEYS.ADMIN,
                    feature: FEATURE_KEYS.ADMIN_MAINTENANCE_DELEGATIONS,
                    telemetryId: TELEMETRY_IDS.CARD_PLATFORM_SUPPORT_DELEGATIONS,
                    accessibilityLabelKey: I18N_KEYS.CARD_PLATFORM_SUPPORT_DELEGATIONS_ACCESSIBILITY,
                    privacyClassification: 'INTERNAL', auditPolicy: 'ALWAYS', owner: 'platform',
                    resourceId: 'platform-support-delegations', routeId: ROUTE_IDS.PLATFORM_SUPPORT_DELEGATIONS_LIST,
                    titleKey: I18N_KEYS.PAGE_PLATFORM_SUPPORT_DELEGATIONS_TITLE,
                    descriptionKey: I18N_KEYS.PAGE_PLATFORM_SUPPORT_DELEGATIONS_DESCRIPTION,
                    iconKey: ICON_IDS.SECURITY, availability: 'AVAILABLE',
                    operationId: OPERATION_IDS.PLATFORM_SUPPORT_DELEGATIONS_LIST,
                },
                {
                    id: 'card.platform.securityPosture', schemaVersion: 1, module: MODULE_KEYS.ADMIN,
                    feature: FEATURE_KEYS.ADMIN_SECURITY_POSTURE, telemetryId: TELEMETRY_IDS.CARD_SECURITY_POSTURE,
                    accessibilityLabelKey: I18N_KEYS.CARD_SECURITY_POSTURE_ACCESSIBILITY,
                    privacyClassification: 'INTERNAL', auditPolicy: 'NONE', owner: 'platform',
                    resourceId: 'platform-security-posture', routeId: ROUTE_IDS.PLATFORM_SECURITY_POSTURE,
                    titleKey: I18N_KEYS.PAGE_SECURITY_POSTURE_TITLE,
                    descriptionKey: I18N_KEYS.PAGE_SECURITY_POSTURE_DESCRIPTION,
                    iconKey: ICON_IDS.LOCK, availability: 'PLANNED',
                    operationId: OPERATION_IDS.PLATFORM_SECURITY_POSTURE_READ,
                },
                {
                    id: 'card.platform.dataProviderHealth', schemaVersion: 1, module: MODULE_KEYS.ADMIN,
                    feature: FEATURE_KEYS.ADMIN_DATA_PROVIDER_HEALTH, telemetryId: TELEMETRY_IDS.CARD_DATA_PROVIDER_HEALTH,
                    accessibilityLabelKey: I18N_KEYS.CARD_DATA_PROVIDER_HEALTH_ACCESSIBILITY,
                    privacyClassification: 'INTERNAL', auditPolicy: 'NONE', owner: 'platform',
                    resourceId: 'platform-data-provider-health', routeId: ROUTE_IDS.PLATFORM_DATA_PROVIDER_HEALTH,
                    titleKey: I18N_KEYS.PAGE_DATA_PROVIDER_HEALTH_TITLE,
                    descriptionKey: I18N_KEYS.PAGE_DATA_PROVIDER_HEALTH_DESCRIPTION,
                    iconKey: ICON_IDS.SUCCESS, availability: 'PLANNED',
                    operationId: OPERATION_IDS.PLATFORM_DATA_PROVIDER_HEALTH_READ,
                },
            ],
        },
    ],
};
